export class Audit {
    int_country_code: number;
    des_country_name: string;
    bol_activated: boolean;
    bol_test_lock: boolean;
    oid_log: string;
    oid_request: string;
    int_operation_type: number;
    int_operation_origin: number;
    des_key: string;
    int_delay: number;
    bol_force_closure: boolean;
    des_dispatcher_id: string;
    des_dispatcher_password: string;
    cod_country: string;
    cod_user_culture: string;
    des_source: string;
    des_user: string;
    des_employee1_id: string;
    des_employee1_password: string;
    des_employee2_id: string;
    des_employee2_password: string;
    des_machine: string;
    int_lock_model: number;
    des_lock_id: string;
    int_child_lock_code: number;
    des_physical_key1: string;
    des_physical_key2: string;
    des_asset_id: string;
    des_serial_number: string;
    des_closure_code: string;
    bol_code_accepted: boolean;
    bol_activation_confirmation: boolean;
    bol_open_forced_closure_confir: boolean;
    des_original_operation_id: string;
    bol_lock_active_only: boolean;
    dtm_request_date_time: string;
    dtm_response_date_time: string;
    des_generated1_code: string;
    des_generated2_code: string;
    des_operation1_id: string;
    des_operation2_id: string;
    int_operation_confirmation: number;
    bol_duress: boolean;
    des_errors: string;
    des_employee1_encryption_code: string;
    des_employee2_encryption_code: string;
    lock_identifier: string;
    int_asset_type: number;
    des_branch_code: string;
    oid_route: string;
    des_route_code: string;
    dat_route_date: string;
    bol_direct_opening: boolean;
    bol_success: boolean;
    des_dispatcher_name: string;
}